<template>
  <div id="app">
    <!-- <BootstrapSizeHelper></BootstrapSizeHelper> -->
    <!-- <DismissibleBanner id="banner"></DismissibleBanner> -->
    <Header id="header" ref="header"></Header>
    <router-view />
    <Footer></Footer>
    <VersionFooter v-if="!isProd"></VersionFooter>
  </div>
</template>

<script>
import Header from "@/base/header/Header.vue";
import Footer from "@/base/Footer.vue";
import VersionFooter from "@/components/utils/VersionFooter";
import BootstrapSizeHelper from "@/utils/BootstrapSizeHelper";
import DismissibleBanner from "@/components/utils/DismissibleBanner";
export default {
  name: "App",
  components: {
    BootstrapSizeHelper,
    Header,
    Footer,
    VersionFooter,
    DismissibleBanner,
  },
  metaInfo() {
    // Based on https://developers.google.com/search/docs/advanced/crawling/localized-versions
    let currentPath = this.$route.fullPath;

    if (currentPath === "/") {
      currentPath = "";
    }

    // Since the default for us is DE, we do not include it
    let obj = {
      link: ["fr", "it", "en"].map((el) => {
        return {
          rel: "alternate",
          href: `${this.domain}${currentPath}?lang=${el}`,
        };
      }),
    };

    return obj;
  },
  watch: {
    $route(to, from) {
      let languages = ["de", "fr", "it"];
      // Language trap. We need to get the language specified by the user
      let lang = to.query.lang;
      if (to.query.lang && languages.indexOf(lang) > -1) {
        this.$store.commit("setLocale", lang);
        this.$i18n.locale = lang;
      }
    },
  },
  beforeMount() {
    // Force a refresh of the regions
    this.$store.dispatch("getRegions", false);
    this.$store.dispatch("getHouseTypes", false);
  },
  data() {
    return {
      isProd: process.env.NODE_ENV === "production",
      domain: process.env.VUE_APP_BASE_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
#banner {
  z-index: 10000 !important;
  position: relative;
}
</style>

<style lang="scss">
// Fonts

// <!-- Vendor CSS -->
@import "../public/porto/vendor/bootstrap/css/bootstrap.min.css";
@import "../public/porto/vendor/font-awesome/css/fontawesome-all.min.css";
@import "../public/porto/vendor/animate/animate.min.css";
@import "../public/porto/vendor/simple-line-icons/css/simple-line-icons.min.css";
@import "../public/porto/vendor/owl.carousel/assets/owl.carousel.min.css";
@import "../public/porto/vendor/owl.carousel/assets/owl.theme.default.min.css";
@import "../public/porto/vendor/magnific-popup/magnific-popup.min.css";

// // <!-- Theme CSS -->
@import "../public/porto/css/theme.css";
@import "../public/porto/css/theme-elements.css";
@import "../public/porto/css/theme-blog.css";
@import "../public/porto/css/theme-shop.css";

// // <!-- Current Page CSS -->
// @import "../public/porto/vendor/rs-plugin/css/settings.css";
// @import "../public/porto/vendor/rs-plugin/css/layers.css";
// @import "../public/porto/vendor/rs-plugin/css/navigation.css";

// // <!-- Demo CSS -->
@import "../public/porto/css/demos/demo-real-estate.css";

// // <!-- Skin CSS -->
@import "../public/porto/css/skins/skin-real-estate.css";

// // <!-- Theme Custom CSS -->
@import "../public/porto/css/custom.css";

// Galleria

// // <!-- DATEPICKER CSS -->
@import "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.8.0/css/bootstrap-datepicker.min.css";

// Font Awesome
@import "https://use.fontawesome.com/releases/v5.14.0/css/all.css";

@import "https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800%7CShadows+Into+Light";

@import url('https://fonts.googleapis.com/css2?family=Noto+Serif:ital,wdth,wght@0,62.5..100,100..900;1,62.5..100,100..900&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
body {
  background-color: $white-01;
}

.contact-list {
  padding-left: 20px !important;
  margin-top: 0px !important;
  padding-bottom: 10px;
}

.row {
  padding-left: 10px;
  padding-right: 10px;
}

.no-row-padding {
  padding-left: 0;
  padding-right: 0;
}

.hidden {
  display: none;
}

/* Color for header & footer */
/* Color for all buttons */
html .btn-primary {
  background-color: $primary-color !important;
  border-color: transparent;
}

html .background-color-primary {
  background-color: $primary-color !important;
}

html .white-text-color {
  color: #ffffff;
}

.grey-text {
  color: #c8c8c8ff !important;
}

#streetViewAlert {
  margin: 16px !important;
}

/* Menu color when compressed */
.fa-bars {
  color: $white;
}

html #header .header-btn-collapse-nav {
  background-color: $primary-color !important;
}

/* Line separator for the footer text */
#footer .footer-copyright .row {
  border-top: 1px solid #fff;
}

/* Line separator for the menu items on mobile */
@media (max-width: 991px) {

  #header {
    position: sticky;
    width: 100%;
  }

  #header .header-nav-main nav > ul > li {
    border-bottom: 1px solid #fff !important;
  }
}

#submitFormButton {
  margin-top: 15px;
}

.disabledCursor {
  cursor: not-allowed;
}
.underlineTitle {
  margin: 0px;
  margin-bottom: 14px;
}

/* Make the gallery buttons always visible */
.owl-carousel.show-nav-hover .owl-nav {
  opacity: 1;
}

/* Tablet breakpoint */
@media (max-width: 991.98px) {
  .vr-button {
    line-height: 40px;
    padding: 7px;
  }

  .vr-button-container {
    height: 40px;
    width: 40px;
  }
}

// html #header .header-nav-main nav > ul > li.dropdown.dropdown-full-color.dropdown-quaternary a {
//     color: $primary-color !important;
// }

// html #header .header-nav-main nav > ul > li.dropdown.dropdown-full-color.dropdown-quaternary > a.active,
// html #header .header-nav-main nav > ul > li.dropdown-full-color.dropdown-quaternary a:focus,
// html #header .header-nav-main nav > ul > li.dropdown-full-color.dropdown-quaternary a:hover {
//     background: $primary-color !important;
//     color: white !important;
// }

// .dropdown-full-color {
//     margin: 0px;
// }

// .dropdown-menu {
//     padding: 0px;
// }

// .dropdown-item {
//     /*background-color: white !important;*/
//     padding: 0px;
// }

// .icon-featured:hover, #propertiesList > li:not(.custom-list-item-disabled) > i {
//     color: $primary-color !important;
// }

.btn {
  font-weight: 500;
  background-color: $primary-color !important;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.btn-primary i {
  color: #ffffff;
}

.btn-outline-primary i {
  color: $primary-color;
}

html .btn-secondary {
  border-color: transparent;
}

.galleria-lightbox-next,
.galleria-lightbox-prev {
  margin-top: -40px !important;
  height: 80px !important;
  width: 60px !important;
  font: bold 54px/70px arial, sans-serif !important;
}

.galleria-lightbox-close {
  height: 40px !important;
  width: 40px !important;
  font: 40px/46px arial, sans-serif !important;
}

#ttt-widget-de-iframe {
  height: 290px;
  width: 450px;
}

.subsentence {
  color: #797d82 !important;
  font-weight: 400 !important;
}

.galleria-container {
  /* Set a min-height so the images are a bit bigger on mobile*/
  min-height: 300px !important;
}

/* START: Weitere preise dropdown*/

/* When expanded*/
html .toggle-primary .toggle.active > label {
  background-color: $primary-color;
  border-color: $primary-color;
}

/* When collapsed */
html .toggle-primary .toggle label {
  color: $text-color;
  border-left-color: $primary-color;
  border-right-color: $primary-color;
}


@media (max-width: 575.98px) {
  html .toggle label {
    display: flex;
    flex-direction: column;
  }
}
/* STOP: Weitere preise dropdown*/



h3 {
  text-transform: none;
}

i {
  color: #373945;
}

.btn-group {
  gap: 5px;
  border-radius: $border-radius;
  overflow: hidden;
}

.dropdown-menu {
  min-width: fit-content !important;
  background-clip: border-box;
  background-color: $white-01;
  border: 0;
}

@media (max-width: 991.98px) {
  .dropdown-menu {
    background-color: $primary-color;
  }
}

// .nav-item.dropdown.base {
//   width: 100% !important;
// }

swiper-container::part(button-prev) {
  color: $primary-color;
}

swiper-container::part(button-next) {
  color: $primary-color;
}

swiper-container::part(bullet-active) {
  background: $primary-color;
}

.pagination .page-item.active .page-link, .pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {
    background-color: $primary-color !important;
    border-color: $primary-color;
}

.feature-box.feature-box-style-2 .feature-box-icon{
    top: 10px;
}



/* Font-Face Definitions */
@font-face {
  font-family: 'Museo Sans';
  font-weight: 700;
  src: url('./assets/fonts/MuseoSans_700.otf');
}

@font-face {
  font-family: 'Noto Serif SC';
  font-weight: 100;
  src: url('./assets/fonts/NotoSerifSC-ExtraLight.otf');
}

html body {
  font-family: 'Noto Serif SC', serif;
  color: $text-color;
  line-height: 1.3;
  letter-spacing: 0.02em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

/* General Headings Styling */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-style: normal;
  font-feature-settings: 'salt' on, 'liga' off;
}

/* Heading Styles */
h1 {
  font-family: 'Noto Serif SC';
  font-weight: 100;
  font-size: 3rem;      /* Default size for h1 */
  line-height: 1.1;

  /* Larger screens */
  @media (min-width: 640px) {
    font-size: 4rem;   /* sm:text-4xl */
    line-height: 1.2;  /* sm:leading-1.2 */
  }
}

h2 {
  font-family: 'Noto Serif SC';
  font-weight: 100;
  font-size: 2.25rem;  /* Default size for h2 */
  line-height: 1.3;

  /* Larger screens */
  @media (min-width: 640px) {
    font-size: 3rem;   /* sm:text-3xl */
    line-height: 1.3;  /* sm:leading-1.3 */
  }
}

h3 {
  font-family: 'Noto Serif SC';
  font-weight: 100;
  font-size: 1.875rem; /* Default size for h3 */
  line-height: 1.3;

  /* Larger screens */
  @media (min-width: 640px) {
    font-size: 2.25rem; /* sm:text-2xl */
    line-height: 1.4;   /* sm:leading-1.4 */
  }
}

h4 {
  font-family: 'Museo Sans';
  font-weight: 700;
  font-size: 1.5rem;    /* Default size for h4 */
  line-height: 1.35;

  /* Larger screens */
  @media (min-width: 640px) {
    font-size: 1.875rem; /* sm:text-xl */
    line-height: 1.4;    /* sm:leading-1.4 */
  }
}

h5 {
  font-family: 'Museo Sans';
  font-weight: 700;
  font-size: 1.25rem;    /* Default size for h5 */
  line-height: 1.35;

  /* Larger screens */
  @media (min-width: 640px) {
    font-size: 1.5rem;   /* sm:text-lg */
    line-height: 1.4;    /* sm:leading-1.4 */
  }
}

h6 {
  font-family: 'Museo Sans';
  font-weight: 700;
  font-size: 1rem;      /* Default size for h6 */
  line-height: 1.3;

  /* Larger screens */
  @media (min-width: 640px) {
    font-size: 1.25rem; /* sm:text-base */
    line-height: 1.4;   /* sm:leading-1.4 */
  }
}

/* General Body and Utility Classes */
html {
  scroll-padding-top: 5rem; /* Equivalent to sm:scroll-pt-20 */
}

.hyphens-auto {
  word-wrap: break-word;
  overflow-wrap: break-word;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  hyphens: auto;
}

strong {
  font-family: 'Open Sans', sans-serif;
}


</style>
